export default __webpack_public_path__ + "static/media/guidesChromecast.8aa225dd.PNG";